import * as React from 'react';

function SvgValidationPin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={34} viewBox="0 0 24 34" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#FF5D52" d="M24 0H0v20.35L11.95 33 24 20.35V11z" />
        <circle cx={12} cy={11} r={5} fill="#FFF" fillRule="nonzero" />
      </g>
    </svg>
  );
}

export default SvgValidationPin;
